import React from "react";
import boostRocket from "assets/boost/boost-rocket-meter.png";
import bgBoostMeter from "assets/boost/bg-boost-meter.png";
import { formatCurrency } from "../utils";

const BoostMeter = ({ amount, min, max, meterHeight = 600 }) => {
  // display the lesser of minimum + added amount and the max amount
  const totalAmount = Math.min(max, min + amount);
  const progress = totalAmount / max;
  const progressLabel = formatCurrency(totalAmount);
  const rocketHeight = meterHeight * 0.15;

  const rocketDisplacementY = 60 + (meterHeight - rocketHeight) * (1 - progress) * (1 - 80 / meterHeight);

  return (
    <div
      className="mt-10 relative text-center w-full border-2 border-white rounded-xl overflow-hidden border-glow-white-sharp bg-black bg-opacity-50"
      style={{
        backgroundImage: `url(${bgBoostMeter})`,
        width: "100%",
        height: "auto",
        minHeight: meterHeight,
        overflow: "hidden",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
      }}
    >
      <div className="p-5 text-2xl font-semibold text-boost-lighter-purple text-left">
        Boost Reporting<span className="text-white">.</span>
      </div>
      <div
        className="text-center mx-auto absolute"
        style={{
          height: rocketHeight,
          width: rocketHeight,
          left: "50%",
          transform: "translateX(-50%)",
          top: rocketDisplacementY,
        }}
      >
        <div className="relative">
          <img
            alt="boost-rocket"
            src={boostRocket}
          />
          <span
            className="absolute font-semibold text-xl"
            style={{
              marginTop: -rocketHeight * 0.5 - 15,
              marginLeft: -rocketHeight * 0.5,
              transform: "translateX(-50%)",
            }}
          >
            {progressLabel}
          </span>
        </div>
      </div>
      <div
        className="vertical-dotted-line h-full"
        style={{
          top: rocketDisplacementY + rocketHeight,
          height: progress * meterHeight - rocketHeight / 2,
        }}
      />
    </div>
  );
};

export default BoostMeter;
